import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MapPin, Clock } from "lucide-react";
import { api } from "@/lib/api";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

export default function AgendaSection() {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    api.get("/agenda").then((r) => setEvents(r.data)).catch(() => {});
  }, []);

  return (
    <section id="agenda" className="bg-[#F4EFE6] px-4 sm:px-8 lg:px-16 py-20 lg:py-32">
      <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce}>
        <motion.p variants={fadeUp} className="overline-label text-[#4A0E17]/60">Agenda Litúrgica</motion.p>
        <motion.h2 variants={fadeUp} className="font-display mt-4 text-4xl sm:text-5xl font-bold uppercase leading-tight text-[#1C1917]">
          Celebrações e Encontros
        </motion.h2>

        <motion.div variants={fadeUp} data-testid="liturgical-agenda-timeline" className="mt-12 border-t border-[#E5DEC9]">
          {events.map((e, i) => {
            const [day, month] = (e.date_label || "").split(" ");
            return (
              <div key={e.id || i} data-testid={`agenda-event-${i}`} className="group grid grid-cols-12 gap-4 sm:gap-8 items-center py-7 border-b border-[#E5DEC9] px-2 sm:px-4 hover:bg-[#FBF9F4] transition-colors">
                <div className="col-span-3 sm:col-span-2 text-center sm:text-left">
                  <span className="font-display block text-3xl sm:text-4xl font-bold text-[#4A0E17]">{day}</span>
                  <span className="overline-label text-[#C5A059]">{month}</span>
                </div>
                <div className="col-span-9 sm:col-span-6">
                  <h3 className="font-display text-lg sm:text-xl font-bold text-[#1C1917]">{e.title}</h3>
                </div>
                <div className="col-span-9 col-start-4 sm:col-span-4 sm:col-start-auto flex flex-col sm:items-end gap-1 text-sm text-[#1C1917]/55">
                  <span className="flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5 text-[#C5A059]" />{e.location}</span>
                  <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5 text-[#C5A059]" />{e.time}</span>
                </div>
              </div>
            );
          })}
          {events.length === 0 && (
            <p data-testid="agenda-empty" className="py-10 text-center text-sm text-[#1C1917]/50">Programação em breve.</p>
          )}
        </motion.div>
      </motion.div>
    </section>
  );
}
